import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/Help';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            backgroundColor: '#000000',
            border: '2px solid #ffd700',
            borderRadius: 2,
            width: '100%',
            maxWidth: 600,
          }}
        >
          <ErrorOutlineIcon 
            sx={{ 
              fontSize: 100, 
              color: '#ffd700',
              mb: 2,
            }} 
          />
          
          <Typography 
            variant="h1" 
            sx={{ 
              color: '#ffd700',
              fontSize: { xs: '4rem', md: '6rem' },
              fontWeight: 'bold',
              mb: 2,
            }}
          >
            404
          </Typography>

          <Typography 
            variant="h4" 
            sx={{ 
              color: '#ffd700',
              mb: 3,
            }}
          >
            Page Not Found
          </Typography>

          <Typography 
            sx={{ 
              color: '#ffd700',
              mb: 4,
              opacity: 0.8,
            }}
          >
            The page you're looking for doesn't exist or has been moved.
          </Typography>

          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Button
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                backgroundColor: '#ffd700',
                color: '#000000',
                '&:hover': {
                  backgroundColor: '#ffed4a',
                },
              }}
            >
              Back to Home
            </Button>
            <Button
              variant="outlined"
              startIcon={<HelpIcon />}
              onClick={() => navigate('/support')}
              sx={{
                borderColor: '#ffd700',
                color: '#ffd700',
                '&:hover': {
                  borderColor: '#ffed4a',
                  backgroundColor: 'rgba(255, 215, 0, 0.1)',
                },
              }}
            >
              Get Support
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound; 